// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { GalleryCarouselCardFragmentDoc } from './carousel/card/GalleryCarouselCard.fragment.generated';
export const ComponentGalleryCarouselFragmentDoc = gql`
    fragment componentGalleryCarousel on ComponentGalleryCarousel {
  __typename
  items {
    ...galleryCarouselCard
  }
}
    ${GalleryCarouselCardFragmentDoc}`;